export const PATHNAMES = [
  {
    ua: `refugee-guide`,
    lt: `informacija-ukrainieciams`,
  },
  {
    ua: `help-search`,
    lt: `pagalba-ukrainai`,
  },
  {
    ua: `privacy-policy`,
    lt: `privatumo-politika`,
  },
  {
    ua: `events`,
    lt: `renginiai`,
  },
];
